var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BModal',{ref:"error-modal",attrs:{"centered":"","hide-header":"","hide-footer":"","no-close-on-backdrop":"","no-close-on-esc":""}},[_c('ErrorContentComponent',{attrs:{"errors-state":_vm.errorsState},on:{"hide":_vm.hide}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }